export default __webpack_public_path__ + "static/media/Dulk.2024cd78.PNG";